import { styled } from '@mui/material';

export const SessionOutcomePrintActionWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
}));
